/**
 * How a member of staff's attendance is written down, on screen and in the
 * export alike — one place, so the tab and the CSV can never disagree about
 * what a day's hours were.
 */

/** "8 hrs 01 min", or a dash where the day has only one end. */
export function formatWorked(minutes: number | null): string {
  if (minutes === null) return '—';
  return `${Math.floor(minutes / 60)} hrs ${String(minutes % 60).padStart(2, '0')} min`;
}

/** An ISO instant down to the `HH:mm` the institute reads it as. */
export function timeOf(isoTimestamp: string): string {
  return new Date(isoTimestamp).toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}
